"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.apiTool.name': 'Solicitud API',
    'tools.apiTool.description': 'Recopila datos de la conversación y envía solicitudes API a endpoints externos configurados',
};
